export default __webpack_public_path__ + "e72b15c0b390c6191c085acf8054e099.png";